import { render, staticRenderFns } from "./ExpData.vue?vue&type=template&id=a007de52&"
import script from "./ExpData.vue?vue&type=script&lang=js&"
export * from "./ExpData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports